import { useMemo } from 'react';

export function useColoredVerificationUri(verificationUri: string) {
  return useMemo(() => {
    const coloredUri = new URL(verificationUri);
    coloredUri.searchParams.set('color', 'developer');
    coloredUri.searchParams.set('studio', 'true');
    const signupUri = new URL('https://users.wix.com/login/signup/password');
    signupUri.searchParams.set('redirectTo', coloredUri.href);
    return {
      coloredVerificationUri: coloredUri.toString(),
      signupUri: signupUri.toString(),
    };
  }, [verificationUri]);
}
